import * as actionTypes from 'modules/checklists/actionTypes';
import type { CreateFailureAction, FetchChecklistFailureAction, UpdateFailureAction } from 'modules/checklists/types';
import type { ApiError } from 'modules/global/generic.types';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDetailsErrorReducer = ApiError | null;

const initialState: ChecklistUiDetailsErrorReducer = null;

const clear = (): ChecklistUiDetailsErrorReducer => null;

const set = (
  _: ChecklistUiDetailsErrorReducer,
  { payload: message }: FetchChecklistFailureAction | UpdateFailureAction | CreateFailureAction
): ChecklistUiDetailsErrorReducer => message;

export default createReducer(initialState, {
  [actionTypes.SET_IS_NEW]: clear,
  [actionTypes.FETCH_REQUEST]: clear,
  [actionTypes.UPDATE_REQUEST]: clear,
  [actionTypes.CREATE_REQUEST]: clear,
  [actionTypes.CREATE_SUCCESS]: clear,
  [actionTypes.FETCH_FAILURE]: set,
  [actionTypes.UPDATE_FAILURE]: set,
  [actionTypes.CREATE_FAILURE]: set,
});
